export class OperatingService {
  static operatingList: string[] = [];

  static addOperating = (key: string) => {
    OperatingService.operatingList.push(key);
  };

  static hasOperate = (): boolean => {
    return OperatingService.operatingList.length > 0;
  };
}



// WEBPACK FOOTER //
// ./src/services/OperatingService.ts